// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getAuth, GoogleAuthProvider } from "firebase/auth";
// const provider = new GoogleAuthProvider();
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD3UxYAiCjf4eXkjJbwE1vaxsouTYOaibg",
  authDomain: "avsflix.firebaseapp.com",
  projectId: "avsflix",
  storageBucket: "avsflix.appspot.com",
  messagingSenderId: "64141383710",
  appId: "1:64141383710:web:09bbd0bcb304b1fec2b60f",
  measurementId: "G-PBS46VZ3DT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
